import React from 'react';
import { useProperty } from '@spotify-internal/remote-config-integration-react';

import { FeedbackStatus, showSurveyOptionEnum } from 'utils/remote-config/properties';
import { UbiArticlePage } from 'utils/ubi/pages/useUbiArticle';
import FeedbackWidget from 'components/Article/FeedbackWidget';

import FeedbackStickyWidget from './FeedbackStickyWidget';

interface FeedbackWidgetControlProps {
  articleIdentifier: string;
  ubi: UbiArticlePage;
}

const FeedbackWidgetControl = (props: FeedbackWidgetControlProps) => {
  const showOriginalWidget =
    useProperty(showSurveyOptionEnum, { loadingValue: FeedbackStatus.ORIGINAL }) === FeedbackStatus.ORIGINAL;

  return showOriginalWidget ? <FeedbackWidget {...props} /> : <FeedbackStickyWidget {...props} />;
};

export default FeedbackWidgetControl;
